<template>
  <svg viewBox="0 0 212 345" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M138.353 76.46H69.4783C66.957 76.46 64.913 74.4124 64.913 71.8867V36.7618C64.913 29.9357 67.4528 23.3546 72.0364 18.3037L79.5883 9.98186C84.7796 4.26132 92.1389 1 99.8562 1H113.563C121.779 1 129.561 4.69415 134.763 11.064L139.994 17.4684C144.54 23.0346 146.723 30.1664 146.073 37.3287L142.899 72.3007C142.685 74.6563 140.714 76.46 138.353 76.46Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.3913 101.613H183.609C186.13 101.613 188.174 103.661 188.174 106.187V127.315C188.174 128.435 187.764 129.516 187.021 130.353L169.913 149.633L208.886 303.635C210.074 308.326 207.408 313.132 202.804 314.599L113.218 343.155C111.489 343.706 109.635 343.728 107.893 343.219L9.60044 314.5C4.82438 313.104 2.04267 308.135 3.34481 303.325L37.5217 177.073L128.826 154.207H52.9932C51.851 154.207 50.7503 153.778 49.9084 153.005L25.3065 130.413C24.3632 129.547 23.8261 128.323 23.8261 127.042V106.187C23.8261 103.661 25.87 101.613 28.3913 101.613ZM126.543 263.967H87.7391L83.415 227.146C83.2638 225.859 83.7462 224.577 84.7092 223.709L103.322 206.928C104.844 205.556 107.156 205.556 108.678 206.928L127.399 223.806C128.301 224.62 128.785 225.799 128.713 227.012L126.543 263.967Z"
      fill="currentColor"
    />
  </svg>
</template>
<style>
svg path {
  fill: currentColor !important;
  stroke: currentColor !important;
}
</style>
